<template>
    <div class="home" :style="{background:type==='0' ? '#F0F8FD' : '#F1F8F2'}">
        <div class="banner">
          <van-swipe :autoplay="4000" style="width: 95%; height: 200px;position: relative;top: 30px;border-radius: 10px;">
            <van-swipe-item v-for="(item,index) in images" :key="index" @click="clickBanner(item)">
              <van-image :src="item.imageUrl" width="100%" height="100%"/>
            </van-swipe-item>
          </van-swipe>
        </div>

<!--        <div id="declare" @click="declare">
            <span style="color: black;z-index:9999">关于保险业务的声明</span>
        </div>-->
        <div class="box" v-if="type==='0'">
           <template v-for="item in items" >
              <div id="test" :key="item.name" class="box-pro-content">
                  <img style="width: 35px; height: 35px; margin: 9px 0 3px 0;" :src="item.src" @click="gotoProduct(item)"/>
                  <div style="font-size: 12px; margin-bottom: 6px;width: 80px;"  @click="gotoProduct(item)">{{item.name}}</div>
              </div>
           </template>

        </div>
        <div class="hot-inclusive" :style="{marginTop:type==='0'?'unset':'20px'}">
              <div style="padding-left: 7px;margin: 10px 0;">
                <div style="height: 18px;width: 3px;float: left;margin-top: 3px; background: #1987F5;"></div>
                <span style="padding-left: 5px;color: black;font-weight: 500;">热门普惠保险</span>
              </div>
              <div style="margin-top: 13px">
                <van-swipe :loop="false" :width="200" :show-indicators = "false">
                  <van-swipe-item v-for="(item,index) in hotImg" :key = "index" style="width: 130px;height: 130px">
                    <van-image :src="item.src" @click="linkUrl(item.id)" :id="item.id" style="margin-left:10px;" />
                  </van-swipe-item>
                </van-swipe>
              </div>






<!--            <div style="width: 40px;margin-right: 10px; font-style: italic; font-weight: bolder; color: #1C7CF8;">-->
<!--                每日头条-->
<!--            </div>-->
<!--            <van-swipe :autoplay="5000" :duration="600" vertical :show-indicators="false"-->
<!--                       style="height: 40px; flex:1; margin-right: 10px;">-->
<!--                <van-swipe-item v-for="item in hots" :key="item.newId" @click="gotoArticleDetail(item)">-->
<!--                    <div style="display: flex; align-items: center;">-->
<!--                        <div style="font-size: 14px; display: flex; flex-direction: column; align-items: start; flex: 1;">-->
<!--                            <span :style="`color: #4E4E4E; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:${windowWidth-190}px;`">{{item.newsTitle}}</span>-->
<!--                            <span :style="`margin-top: 2px; color: #999999; font-size: 12px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:${windowWidth-190}px;`">{{item.abstracts}}</span>-->
<!--                        </div>-->
<!--                        <van-button type="info" round-->
<!--                                    style="background-color: #1C7CF8; font-size: 14px; height: 28px; line-height: 28px;"-->
<!--                                    @click="gotoArticleDetail(item)">立即参与-->
<!--                        </van-button>-->
<!--                    </div>-->
<!--                </van-swipe-item>-->
<!--            </van-swipe>-->
        </div>

        <div class="line" v-if="type === '0'">
          <div style="padding-left: 7px;padding-top: 15px;padding-bottom:5px;">
            <div style="height: 18px;width: 3px;float: left;margin-top: 3px; background: #1987F5;"></div>
            <span style="padding-left: 5px;color: black;font-weight: 500;">普惠保险</span>
          </div>
            <van-tabs v-model="active" swipeable animated sticky color="#066BEE" line-height="2px"
                      @change="getProductListData(active)">
                <van-tab v-for="item in list" :key="item.title" :title="item.title" style="border-top: 1px solid #ebedf0;">
                    <van-list>
                        <van-cell v-for="(subItem,index) in item.list" :key="index" @click="gotoProductDetail(subItem)" role="button" :aria-labelledby="item.prodTag == '1' ? ['prodName' + index] : [ item.prodTag == '2' ? ['prodNameT' + index]:['prodNameG' + index]]">
                            <template slot="title">
                                <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
                                    <van-image :src="subItem.image" width="67px" height="67px" radius="6px"/>
                                    <div style="flex: 1; margin-left:12px; margin-top: 2px; display: flex; flex-direction: column; align-items: start;" :id="item.prodTag == '1' ? ['prodName' + index] : [ item.prodTag == '2' ? ['prodNameT' + index]:['prodNameG' + index]]" aria-hidden="true">
                                        <div style="color: #4E4E4E; font-size: 16px; font-weight: bolder;">
                                            {{subItem.prodName}}
                                        </div>
                                        <div :style="`color: #666666; font-size: 14px; white-space: nowrap; width: ${windowWidth - 130}px; overflow: hidden; text-overflow:ellipsis;`">
                                            {{subItem.prodDescribe}}
                                        </div>
                                        <div style="color: #066BEE; font-size: 18px;width: 100%; font-weight: bolder;display: flex;justify-content: space-between;align-items:center;">
                                            <div> {{`¥${subItem.price||'1'}`}}
                                                <span style="color: #999999; font-size: 14px;">元起</span>
                                            </div>
                                            <van-icon id="'rightArrow' + index" style="left: -15px" name="arrow" color="#999999"/>
                                        </div>
                                    </div>

                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="点击查看更多" style="text-align: center;" :border="false" @click="moreProduct"/>
                    </van-list>
                </van-tab>
            </van-tabs>
        </div>
        <div class="line" v-else>
            <van-cell v-for="(subItem,index) in list[0].list" :key="index" @click="gotoProductDetail(subItem)" role="button" style="border-radius: 10px;" :aria-labelledby="['prodNameG' + index]">
                <template slot="title">
                    <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
                        <img :src="subItem.image" width="67px" height="67px">
                        <div :id="'prodNameG' + index" aria-hidden="true" style="flex: 1; margin-left:12px; display: flex; flex-direction: column; align-items: start;">
                            <div style="color: #4E4E4E; font-size: 16px; font-weight: bolder;">{{subItem.prodName}}
                            </div>
                            <div :style="`color: #666666; font-size: 14px; white-space: nowrap; width: ${windowWidth - 130}px; overflow: hidden; text-overflow:ellipsis;`">
                                {{subItem.prodDescribe}}
                            </div>
                            <div style="color: #066BEE; font-size: 18px; font-weight: bolder">
                                {{`¥${subItem.price||'1'}`}}<span
                                    style="color: #999999; font-size: 14px;">元起</span></div>
                        </div>
                        <van-icon id="rightArrow2" style="left: 15px !important;" name="arrow" color="#999999"></van-icon>
                    </div>
                </template>
            </van-cell>
            <van-cell title="点击查看更多" style="text-align: center;" :border="false" @click="moreProduct"/>
        </div>



      <div>
        <van-overlay :show="show" @click="show = false">
          <div class="wrapper" @click="show = false">
            <img src="@/assets/erweima-1.png"/>
          </div>
        </van-overlay>
        <div @click="clickShequn" style="width: 95%;margin: 20px auto 0px;">
          <van-image src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/image.png" fit="cover" width="100%" height="100%"/>
        </div>
        <div @click="show = true" style="width: 95%;margin: 14px auto 0px;">
          <img v-if="type==='0'" style="height: 100%;width: 100%" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/16.png"/>
          <img v-else style="height: 100%;width: 100%" src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/xinzhibao/8.png"/>
        </div>
      </div>

      <div style="width: 30%;height: 25%;margin: 15px auto;">
        <van-image src="https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/logo002.png" fit="cover" width="100%" height="100%"/>
      </div>

      <div style="color: RGB(147, 147, 147);text-align: center;margin: 0 auto;width: 80%;padding-bottom: 20px;">
        <span style="font-size: 10px;">益宝平台仅提供产品展示和推广支持服务，保险产品由保险公司负责提供，由保险经纪公司负责销售</span>
      </div>


    </div>
</template>

<script>

    import  Vue from 'vue';
    import {Swipe, SwipeItem, Tab, Tabs, List, Cell, Icon, Image, Dialog, Grid, GridItem, Overlay} from 'vant';
    import Cookies from 'js-cookie'
    import {wxChatShare} from '@/utils/wxShare'

    Vue.use(Swipe).use(SwipeItem).use(Tab).use(Tabs).use(List).use(Cell).use(Icon).use(Image).use(Grid).use(GridItem).use(Overlay);

    export default {
        name: 'home',
        components: {},
        props: ['aria-labelledby'],
        data() {
            return {
                windowWidth: window.outerWidth,
                type: Cookies.get('type'),
                active: 0,
                images: [],
                hots: [],
                show: false,
                articles: [],
                ambassadors: [],
                twoCateList:[],
                error: false,
                loading: false,
                finished: false,
                user: this.$store.state.user.user,
                list: Cookies.get('type') === '0' ? [
                    {title: '公益人', type: 0, prodTag: '3', list: []},
                    {title: '社区居民', type: 0, prodTag: '4', list: []},
                    {title: '公益组织', type: 0, prodTag: '5', list: []}
                ] : [
                    {title: '心智宝', type: 1, list: []}
                ],
            }
        },
        computed: {
            items: function () {
                if (Cookies.get('type') === '0') {
                    return [
                      {
                        src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/10.png',
                        name: "公益人",
                        cateCode: '3'
                      },
                      {
                        src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/11.png',
                        name: "社区居民",
                        cateCode: '4'
                      },
                      {
                        src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/12.png',
                        name: "公益组织",
                        cateCode: '5'
                      },

                    ]
                } else {
                    return [
                        {src: 'https://yibaodata.oss-cn-beijing.aliyuncs.com/h5_img/assets/%E8%87%AA%E9%97%AD%E7%97%87.png', name: "自闭症"},
                        {src: 'https://yibaodata.oss-cn-beijing.aliyuncs.com/h5_img/assets/%E8%84%91%E7%98%AB.png', name: '脑瘫'},
                        {src: 'https://yibaodata.oss-cn-beijing.aliyuncs.com/h5_img/assets/%E5%94%90%E6%B0%8F%E7%BB%BC%E5%90%88%E7%97%87.png', name: '唐氏综合症'},
                        {src: 'https://yibaodata.oss-cn-beijing.aliyuncs.com/h5_img/assets/%E6%99%BA%E5%8A%9B%E9%9A%9C%E7%A2%8D.png', name: '智力障碍'}
                    ]
                }
            },
          hotImg:function () {
            if (Cookies.get('type') === '0'){
              return [
                {src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/13.png',id: "1458277228851924992"},
                {src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/14.png',id: "1216975243114860544"},
                {src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/15.png',id: "1599583470429962240"},

              ]
            }else{
              return [
                {src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/xinzhibao/2.png',id: "1599613492272332800"},
                {src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/xinzhibao/3.png',id: "1216975243114860544"},
                {src: 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/xinzhibao/4.png',id: "1515714160960094208"},

              ]
            }

          }

        },
        created() {
            this.getBannerImage();
            this.getArticle('1');
            this.getArticle('2');
            this.getProductListData(this.active);
            this.getAmbassadorList();
            this.getSecorndCateCodeData();
            // alert('因益小宝客服号发生故障暂停使用，如有咨询请添加心智小宝微信号联系我们， 也可拨打电话：17710915695')

        },
        mounted() {
            this.settingShare()
            if (this.$route.query.shareId) {
                this.$axios.get("/love/viewShare", {params: {userId: this.$route.query.shareId}})
            }
        },
        methods: {
            settingShare() {
                let name = this.user.userName || this.user.loginName
                // let title = this.type === '0' ? '向您推荐益+（普惠保险服务平台）' : '向您推荐了心智宝（心智障碍者保障平台）'
                let title = ' 向您推荐益+普惠保险综合服务平台'
                let param = {
                    url: window.location.href.split('#')[0], // 当前页面url
                    title: "【" + name + "】" + title, // 分享数据配置 主标题
                    desc: '研究倡导 | 金融教育 | 产品研发 | 公益金融', // 分享数据配置 副标题
                    link: process.env.VUE_APP_SHARE_URL + '?shareId=' + this.user.userId + '&type=' + this.type, // 分享数据配置
                    imgUrl: this.type === '0' ? 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/ffc1433112fa6e4145975ead651ae2ea.png' : 'https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20191014/fc038003a2ec7ae47b3bd2480f18ead5.png', // 分享数据配置 －－ 全路径
                    type: "link", // 分享类型,music、video或link，不填默认为link
                    dataUrl: " ", // 如果type是music或video，则要提供数据链接，默认为空
                }
                wxChatShare(param);
            },
            role() {
                return this.$store.state.user.role ? this.$store.state.user.role : '0'
            },
            show1(){
              this.show = true;
            },
          gotoProduct(item) {
              this.$router.push({path: '/productList', query: {id: item.cateCode}})
          },
            gotoArticleDetail(item) {
                if (item.newsUrl.length > 0) {
                    window.location.href = item.newsUrl
                } else {
                    // this.$router.push({path: '/articleDetail', query: {newsId: item.newsId}})
                    window.location.href = `${process.env.VUE_APP_SHARE_URL}/articleDetail?newsId=${item.newsId}`
                }
            },
            gotoProductDetail(item) {
                 //add by cpgu 2023/01/15 begin
                if(item['isEnterCustDetailPage']){
                  this.$router.push({path: '/custProductDetail', query: {id: item.productId}})
                  return;
                }
                //end by cpgu

                //产品为特殊产品，需要直接跳转到外部链接
                if(item.prodShape ==='1' && item.jumpConnection){
                  window.location.href = item.jumpConnection
                  return;
                }
                if (item.prodShape === '1' || item.prodType === '1') {
                    this.$router.push({path: '/productDetail', query: {id: item.productId}})
                } else {
                    this.$axios.get("/jump/prodUrl", {
                        params: {
                            productId: item.productId,
                            shareId: Cookies.get('shareId')
                        }
                    }).then(res => {
                        // window.location.href = res.data
                        window.open(res.data, '_parent')
                    });
                }
            },
            getBannerImage() {
                this.$axios.get("/image/shuffling", {params: {imageType: '5', imageBelong: this.type}}).then(res => {
                    this.images = res.data;
                });
            },
            getArticle(status) {//status  1为普通文章  2 为热点文章
                this.$axios.get("/article/list", {
                    params: {
                        type: '5',
                        status: status,
                        newsBelong: this.type
                    }
                }).then(res => {
                    if (status == '1') {
                        this.articles = res.data.rows;
                    } else {
                        this.hots = res.data.rows;
                    }
                });
            },
            getProductListData(active) {
                let item = this.list[active]
                let params = {params: {type: item.type}}
                if (item.prodTag) {
                    params.params['prodTag'] = item.prodTag
                }
                this.$axios.get("/product/list", params).then(res => {
                    item.list = res.data.rows;
                });
            },
            async getSecorndCateCodeData() {
              await this.$axios.get("/product/two-cate-num").then(res => {
                this.twoCateList = res.data;
              });
            },
            moreProduct() {
                this.$router.push('/productList');
                // window.location.href = `${process.env.VUE_APP_SHARE_URL}/productList`
            },
            getAmbassadorList() {
                this.$axios.get("/ambassador/list", {params: {type: this.type}}).then(res => {
                    this.ambassadors = res.data.rows;
                })
            },
            gotoAbbassadorDetail(id) {
                // this.$router.push({path: '/ambassadorDetail', query: {id: id}})
                window.location.href = `${process.env.VUE_APP_SHARE_URL}/ambassadorDetail?id=${id}`
            },
            readMoreAbbassadors() {
                this.$router.push('/ambassadorList')
            },
            declare(){
                Dialog.alert({
                    message: '公众声明：本平台仅提供保险产品的技术支持与展示，承保与理赔等服务由合作保险公司与保险经纪公司提供',
                    title: '系统提示'}
                    )
            },
          linkUrl(id){
              this.$axios.get("/jump/prodUrl", {
                params: {
                  productId: id,
                  shareId: Cookies.get('shareId')
                }
              }).then(res => {
                window.location.href = res.data
              });
          },
          clickBanner(itm){
            if(itm['imageJumpUrl']){
              window.location.href = itm['imageJumpUrl']
            }
          },
          clickShequn(){
            window.location.href='http://shequ.yibaojihua.com';
          },


        }
    }
</script>

<style scoped>
    .home {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #F0F8FD;
    }

    .home .van-swipe__indicators {
        bottom: 30px;
    }
    .banner{
      background-image: url("https://yibaoobj.oss-cn-shanghai.aliyuncs.com/prod/h5/yibao/00.png");
      width: 100%;
      height: 180px;
      background-position: center center;
      background-size: cover;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 40px;
    }

    .box {
        margin: 20px 0;
        flex-wrap: wrap;
        background-color: white;
        position: relative;
        display: flex;
        justify-content: space-evenly;
        box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
        border-radius: 10px;
        width: 95%;
        align-self: center;
        text-align: left;
        flex-flow: row wrap;
        font-weight: 500;



    }
    .box-pro-content{
     /*
     flex: 1 1 24%;
     */
      width: 80px;
      height: 76px;
      text-align: center;
    }
    .hot-inclusive{
      width: 95%;
      align-items: center;
      box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
      border-radius: 10px;
      background: white;
    }

    .line {
      background: white;
      width: 95%;
      box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
      border-radius: 10px;
      margin-top: 20px;
    }

    .title {
        align-self: start;
        margin: 10px 0 10px 23px;
        text-align: start;
        font-size: 14px;
        font-weight: bolder;
    }

    .title::before {
        background-color: #1C7CF8;
        content: '';
        width: 3px;
        height: 14px;
        position: relative;
        right: 3px;
        top: 2px;
        display: inline-block;
    }
    #declare{
        position: absolute;
        z-index: 99999;
        background-color: rgba(255,255,255,0.6);
        top: 104px;
        left: 30px;
        padding: 2px 8px;
        line-height: 1.2rem;
        border-radius: 2.75rem;
        box-shadow: 0 0 4px rgba(0,0,0,.4);
        font-size: 0.8rem;
    }
</style>

<style>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  z-index: 9999;
}

.block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}
</style>
